import React from 'react';

/**
 * Static footer component for Hyrule
 */
const HyruleFooter = () => /*#__PURE__*/React.createElement("footer", {
  className: "footer"
}, /*#__PURE__*/React.createElement("div", {
  className: "container"
}, /*#__PURE__*/React.createElement("p", {
  className: "text-muted"
}, "\xA9 ", new Date().getFullYear(), " Nintendo")));
export default HyruleFooter;